import { useEffect, useState } from 'react';
import { parse } from 'valibot';

import { LOCAL_STORAGE_KEY_SHOPPING_CART_LIST } from './constants';
import type { Hook } from './types';
import { shoppingCartListSchema } from './validation';

export const useShoppingCartCount: Hook = () => {
  const [shoppingCartCount, setShoppingCartCount] = useState(0);

  useEffect(() => {
    const localStorageShoppingCartList = window.localStorage.getItem(
      LOCAL_STORAGE_KEY_SHOPPING_CART_LIST,
    );

    if (!localStorageShoppingCartList) {
      setShoppingCartCount(0);

      return;
    }

    try {
      const {
        items: {
          length: shoppintCartItemsLength,
        },
      } = parse(
        shoppingCartListSchema,
        JSON.parse(localStorageShoppingCartList),
      );

      setShoppingCartCount(shoppintCartItemsLength);
    } catch (e) {
      setShoppingCartCount(0);
    }
  }, []);

  return {
    count: shoppingCartCount,
  };
};
